/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from 'rxjs';
import { requestAnonymous, requestAuthenticated, Optional, RequestOption, HttpHeaders, throwIfNullOrUndefined } from '../runtime';
import {
    OAuthTokenResponse,
    RESTAuthCode,
    RESTExceptionInfo,
} from '../models';

export interface TokenRequest {
    grantType: TokenGrantTypeEnum;
    username?: string;
    password?: string;
    refreshToken?: string;
    clientId?: string;
    assertion?: string;
    disableAntiforgeryToken?: boolean | null;
}

/**
 * no description
 */
export const authApi = ({

    /**
     * Creates a one-time authorization code.
     * Request Authorization Code
     */
    authCode: (option?: RequestOption): Observable<Optional<RESTAuthCode>> => {
        const headers: HttpHeaders = {
        };

        return requestAuthenticated<RESTAuthCode>({
            url: '/v8/token/AuthCode',
            method: 'POST',
            headers,
        }, option);
    },

    /**
     * Performs the logout operation for an authorized user.
     * Log Out
     */
    logout: (option?: RequestOption): Observable<Optional<void>> => {
        const headers: HttpHeaders = {
        };

        return requestAuthenticated<void>({
            url: '/v8/token/logout',
            method: 'POST',
            headers,
        }, option);
    },

    /**
     * Allows you to authorize your access to the Veeam Backup for Microsoft 365 REST API.
     * Request Authorization Tokens
     */
    token: ({ grantType, username, password, refreshToken, clientId, assertion, disableAntiforgeryToken }: TokenRequest, option?: RequestOption): Observable<Optional<OAuthTokenResponse>> => {
        throwIfNullOrUndefined(grantType, 'grantType', 'token');

        const headers: HttpHeaders = {
        };

        const formData = {
            'grant_type': grantType,
            'username': username,
            'password': password,
            'refresh_token': refreshToken,
            'client_id': clientId,
            'assertion': assertion,
            'disable_antiforgery_token': disableAntiforgeryToken,
        }

        return requestAnonymous<OAuthTokenResponse>({
            url: '/v8/token',
            method: 'POST',
            headers,
            body: formData,
        }, option);
    },

})

/**
 * @export
 * @enum {string}
 */
export enum TokenGrantTypeEnum {
    Password = 'password',
    RefreshToken = 'refresh_token',
    UrnietfparamsoauthgrantTypejwtBearer = 'urn:ietf:params:oauth:grant-type:jwt-bearer',
    Operator = 'operator'
}
